<template>
    <section :class="$style.impersonationHeader">
        <div :class="$style.impersonateWrapper">
            <p>You're acting as <span>{{ getLocalStorageFoundryImpersonated }}</span>. Everything you do is live.</p>
            <button @click="stopImpersonation">Stop impersonating</button>
        </div>
    </section>
</template>
<script type="text/ecmascript-6" src="./script/index.js"></script>
<style lang="scss" src='./stylesheets/index.scss' module></style>